import { ScoreCardService } from './../../../../../../shared/service/score-card.service';
import { MatSelectModel } from 'src/app/shared/model/score-card.model';
import { filter } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { MESSAGE_TOAST } from './../../../../../../shared/enums/message-toast-enum';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors } from '@angular/forms';
import { thresholdFreedmanDiaconis } from 'd3-array';
import * as _moment from 'moment';
import { Moment } from 'moment';
import { DateTimeAdapter, OwlDateTimeComponent, OwlDateTimeFormats, OWL_DATE_TIME_FORMATS, OWL_DATE_TIME_LOCALE } from 'ng-pick-datetime';
import { MomentDateTimeAdapter } from 'ng-pick-datetime/date-time/adapter/moment-adapter/moment-date-time-adapter.class';
import { ToastrService } from 'ngx-toastr';
import { Spinner } from 'src/app/core/services/spinner.service';
import { CustomValidator } from 'src/app/shared/directive/custom-validator';
import { ASSESSMENT, CONDITION, KPISetting, KPI_FORMGROUP, ScorecardSettingModel } from 'src/app/shared/model/scorecard-setting.model';
import { ScorecardSettingService } from 'src/app/shared/service/scorecard-setting.service';
import { PATH_ROUTING } from 'src/app/shared/enums/routing-enums';

const moment = (_moment as any).default ? (_moment as any).default : _moment;
const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export const MY_MOMENT_DATE_TIME_FORMATS: OwlDateTimeFormats = {
  parseInput: 'YYYY',
  fullPickerInput: 'LT',
  datePickerInput: 'YYYY',
  timePickerInput: 'LT',
  monthYearLabel: 'YYYY',
  dateA11yLabel: 'LL',
  monthYearA11yLabel: 'YYYY',
};

@Component({
  selector: 'app-create-edit-scorecard-setting',
  templateUrl: './create-edit-scorecard-setting.component.html',
  styleUrls: ['./create-edit-scorecard-setting.component.scss'],
  providers: [
    { provide: DateTimeAdapter, useClass: MomentDateTimeAdapter, deps: [OWL_DATE_TIME_LOCALE] },

    { provide: OWL_DATE_TIME_FORMATS, useValue: MY_MOMENT_DATE_TIME_FORMATS },
  ]
})
export class CreateEditScorecardSettingComponent implements OnInit, AfterViewInit {

  kpiAccessment = [
    {
      [ASSESSMENT.RELATIONSHIP_ASSEMSSENT]: [
        {
          name: KPI_FORMGROUP.RELATION_COMPLIANCE_INTEGRITY.name,
          formGroupName: KPI_FORMGROUP.RELATION_COMPLIANCE_INTEGRITY.key,
          maxScore: KPI_FORMGROUP.RELATION_COMPLIANCE_INTEGRITY.maxScore
        },
        {
          name: KPI_FORMGROUP.RELATION_TECHNOLOGY_INNOVATION.name,
          formGroupName: KPI_FORMGROUP.RELATION_TECHNOLOGY_INNOVATION.key,
          maxScore: KPI_FORMGROUP.RELATION_TECHNOLOGY_INNOVATION.maxScore
        },
        {
          name: KPI_FORMGROUP.RELATION_RESPONSIVENESS.name,
          formGroupName: KPI_FORMGROUP.RELATION_RESPONSIVENESS.key,
          maxScore: KPI_FORMGROUP.RELATION_RESPONSIVENESS.maxScore
        },
        {
          name: KPI_FORMGROUP.RELATION_SC_COMPETENCY_FOOTPRINT.name,
          formGroupName: KPI_FORMGROUP.RELATION_SC_COMPETENCY_FOOTPRINT.key,
          maxScore: KPI_FORMGROUP.RELATION_SC_COMPETENCY_FOOTPRINT.maxScore
        },
        {
          name: KPI_FORMGROUP.RELATION_GE_FLEXIBILITY_SWITCH.name,
          formGroupName: KPI_FORMGROUP.RELATION_GE_FLEXIBILITY_SWITCH.key,
          maxScore: KPI_FORMGROUP.RELATION_GE_FLEXIBILITY_SWITCH.maxScore
        }
      ],
    },
    {
      [ASSESSMENT.PERFORMANCE_ASSEMSSENT]: [
        {
          name: KPI_FORMGROUP.PERFORM_TOTAL_QUALITY_SCORE.name,
          formGroupName: KPI_FORMGROUP.PERFORM_TOTAL_QUALITY_SCORE.key,
          maxScore: KPI_FORMGROUP.PERFORM_TOTAL_QUALITY_SCORE.maxScore
        },
        {
          name: KPI_FORMGROUP.PERFORM_ESCAPING_DEFECTS.name,
          formGroupName: KPI_FORMGROUP.PERFORM_ESCAPING_DEFECTS.key
        },
        {
          name: KPI_FORMGROUP.PERFORM_YOY_COST_OUT_SUPPLIER_PRICE.name,
          formGroupName: KPI_FORMGROUP.PERFORM_YOY_COST_OUT_SUPPLIER_PRICE.key
        },
        {
          name: KPI_FORMGROUP.PERFORM_YOY_COST_OUT_PCO.name,
          formGroupName: KPI_FORMGROUP.PERFORM_YOY_COST_OUT_PCO.key,
          maxScore: KPI_FORMGROUP.PERFORM_YOY_COST_OUT_PCO.maxScore
        },
        {
          name: KPI_FORMGROUP.PERFORM_OTD_PROMISED_DATE.name,
          formGroupName: KPI_FORMGROUP.PERFORM_OTD_PROMISED_DATE.key,
          maxScore: KPI_FORMGROUP.PERFORM_OTD_PROMISED_DATE.maxScore
        },
        {
          name: KPI_FORMGROUP.PERFORM_OTD_PLAN_NEEDS.name,
          formGroupName: KPI_FORMGROUP.PERFORM_OTD_PLAN_NEEDS.key
        },
        {
          name: KPI_FORMGROUP.PERFORM_DATE_LATE_PROMISED_DATE.name,
          formGroupName: KPI_FORMGROUP.PERFORM_DATE_LATE_PROMISED_DATE.key
        },
        {
          name: KPI_FORMGROUP.PERFORM_DATE_LATE_PLAN_NEEDS.name,
          formGroupName: KPI_FORMGROUP.PERFORM_DATE_LATE_PLAN_NEEDS.key
        },
        {
          name: KPI_FORMGROUP.PERFORM_PAYMENT_DATE_TARGET.name,
          formGroupName: KPI_FORMGROUP.PERFORM_PAYMENT_DATE_TARGET.key,
          maxScore: KPI_FORMGROUP.PERFORM_PAYMENT_DATE_TARGET.maxScore
        },
        {
          name: KPI_FORMGROUP.PERFORM_LEAD_TIME_TARGET.name,
          formGroupName: KPI_FORMGROUP.PERFORM_LEAD_TIME_TARGET.key,
          maxScore: KPI_FORMGROUP.PERFORM_LEAD_TIME_TARGET.maxScore
        },
        {
          name: KPI_FORMGROUP.PERFORM_SUSTAINABILITY.name,
          formGroupName: KPI_FORMGROUP.PERFORM_SUSTAINABILITY.key,
          maxScore: KPI_FORMGROUP.PERFORM_SUSTAINABILITY.maxScore
        },
        {
          name: KPI_FORMGROUP.PERFORM_GE_CORE_REQUIREMENT.name,
          formGroupName: KPI_FORMGROUP.PERFORM_GE_CORE_REQUIREMENT.key
        },
        {
          name: KPI_FORMGROUP.PERFORM_CARBON_PERFORMANCE.name,
          formGroupName: KPI_FORMGROUP.PERFORM_CARBON_PERFORMANCE.key
        },
        {
          name: KPI_FORMGROUP.PERFORM_OVERALL_ECO_VADIS.name,
          formGroupName: KPI_FORMGROUP.PERFORM_OVERALL_ECO_VADIS.key
        },
        {
          name: KPI_FORMGROUP.PERFORM_OVERALL_ECO_VADIS_DEVELOPMENT.name,
          formGroupName: KPI_FORMGROUP.PERFORM_OVERALL_ECO_VADIS_DEVELOPMENT.key
        },
        {
          name: KPI_FORMGROUP.PERFORM_FINANCIAL_HEALTH_RATING.name,
          formGroupName: KPI_FORMGROUP.PERFORM_FINANCIAL_HEALTH_RATING.key,
          maxScore: KPI_FORMGROUP.PERFORM_FINANCIAL_HEALTH_RATING.maxScore
        },
        {
          name: KPI_FORMGROUP.PERFORM_APQP4Wind.name,
          formGroupName: KPI_FORMGROUP.PERFORM_APQP4Wind.key
        },
        {
          name: KPI_FORMGROUP.PERFORM_MAJOR_DISRUPTION.name,
          formGroupName: KPI_FORMGROUP.PERFORM_MAJOR_DISRUPTION.key
        }
      ]
    }
  ];
  KPI_FORMGROUP = KPI_FORMGROUP;
  conditions = CONDITION;
  isEditMode = false;
  parentNames: any[] = [];
  parents: any[] = [];
  gsls = [];
  gslValues = [];
  oldParent: MatSelectModel[] = [];

  isEdit = false;

  formGroup: FormGroup;

  configSelected = new ScorecardSettingModel();
  oldParents: MatSelectModel[] = [];
  behaviorScoreValid: boolean = false;
  performScoreValid: boolean = false;

  constructor(
    private spinner: Spinner,
    private scorecardSettingService: ScorecardSettingService,
    private toastr: ToastrService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private scorecardService: ScoreCardService
  ) {
    this.buildFormGroup();
    this.getParentCompany();
  }

  async ngOnInit() {
    await this.getGSLNumbers();
    this.activatedRoute.params.subscribe(res => {
      if (res.year) {
        this.isEdit = true;
        const parent = decodeURI(res.parentURI);
        if (res.gsl) {
          this.gslValues = [{ name: this.gsls.filter(item => item.value === res.gsl)[0].name, value: decodeURI(res.gsl) }];
        } else if (res.parentURI && parent !== 'Default Setting') {
          this.parents = [{ name: decodeURI(res.parentURI), value: decodeURI(res.parentURI) }];
        } else {
          this.formGroup.controls.type.setValue(0);
        }
        this.getOne(parent, res.year, res.gsl);
      }
    });
    if (!this.isEdit) {
      this.getDefaultSetting();
    }
  }

  ngAfterViewInit() {
  }

  public getDefaultSetting() {
    this.scorecardSettingService.getDefaultSetting().subscribe(res => {
      if (res) {
        this.configSelected = res.data;
        this.configSelected.settings.forEach(item => {
          if (this.formGroup.controls[item.indicators]) {
            this.formGroup.controls[item.indicators].setValue({
              rangeBelowOperator: (item.rangeBelowOperator !== undefined && !this.formGroup.controls[item.indicators].disabled) ? item.rangeBelowOperator : '',
              rangeExceedOperator: (item.rangeExceedOperator !== undefined && !this.formGroup.controls[item.indicators].disabled) ? item.rangeExceedOperator : '',
              rangeMeetBelow: (item.rangeMeetBelow !== undefined && !this.formGroup.controls[item.indicators].disabled) ? item.rangeMeetBelow : '',
              rangeMeetExceed: (item.rangeMeetExceed !== undefined && !this.formGroup.controls[item.indicators].disabled) ? item.rangeMeetExceed : '',
              scoringBelow: typeof (item.scoringBelow) === 'number' ? item.scoringBelow : '',
              scoringMeet: typeof (item.scoringMeet) === 'number' ? item.scoringMeet : '',
              scoringExceed: typeof (item.scoringExceed) === 'number' ? item.scoringExceed : ''
            });
          }
        });
      }
    });
  }

  public getResultFiltered(name, value) {
    const data = value.slice();
    if (data[0] === 'All') {
      data.shift();
    }
    if (name === 'parent') {
      this.formGroup.controls.parentNames.setValue(data.map(item => item.value));
      // this.getGSLByParent(this.formGroup.controls.parentNames.value);
      this.parents = value.slice();
      if (this.parents[0] === 'All') {
        this.parents.shift();
      }

      const newParents = this.parents.filter(item => {
        return this.oldParents.filter(item2 => {
          return item.value === item2.value;
        }).length === 0;
      });
      this.oldParents = this.parents.slice();
      // this.parents = data.map(item => item.value);
      this.scorecardService.getGSLsByParent(this.parents.map(item => item.value)).subscribe((res) => {
        if (res.data.length > 0) {
          this.gsls = res.data.map(item => ({
            name: `${item.s}/${item.g}`,
            value: item.g,
            parentName: item.p,
            suplierName: `${item.s}/${item.g}`
          }));

          if (newParents.length > 0) {
            newParents.forEach(item => {
              const newGSL = this.gsls.filter(item2 => item.value === item2.parentName);
              this.gslValues.push(...newGSL);
            });
          }

          if (this.gslValues.length > 0) {
            const gslNumbers = [];
            this.parents.forEach(item => {
              gslNumbers.push(...this.gslValues.filter(gsl => gsl.parentName === item.value));
            });
            this.gslValues = gslNumbers;
          }
        } else {
          this.gsls = [];
          this.gslValues = [];
        }
        // this.gslValues = res.data.map(item => ({ value: item.g, name: item.s + '/' + item.g }));
        this.formGroup.controls.gsls.setValue(this.gslValues.map(item => item.value));
      });
    } else if (name === 'gsl') {
      this.gslValues = data;
      this.formGroup.controls.gsls.setValue(data.map(item => item.value));
    }
  }

  async getGSLNumbers() {
    this.spinner.show();
    const res = await this.scorecardSettingService.getGSLNumbers().toPromise();
    this.spinner.hide();
    if (res.data) {
      this.gsls = res.data.map(item => ({value: item.g, name: item.s + '/' + item.g}));
    }
  }

  private buildFormGroup() {
    this.formGroup = new FormGroup({
      type: new FormControl(1, [CustomValidator.required]),
      parentNames: new FormControl(''),
      gsls: new FormControl(''),
      year: new FormControl(moment()),
    });
    this.kpiAccessment.forEach(assessment => {
      assessment[Object.keys(assessment)[0]].forEach(kpi => {
        this.formGroup.addControl(kpi.formGroupName, this.addFormGroupToFormGroup());
        if (kpi.name === KPI_FORMGROUP.PERFORM_ESCAPING_DEFECTS.name || kpi.name === KPI_FORMGROUP.PERFORM_YOY_COST_OUT_SUPPLIER_PRICE.name
          || kpi.name === KPI_FORMGROUP.PERFORM_OTD_PLAN_NEEDS.name || kpi.name === KPI_FORMGROUP.PERFORM_DATE_LATE_PROMISED_DATE.name
          || kpi.name === KPI_FORMGROUP.PERFORM_DATE_LATE_PLAN_NEEDS.name 
          || kpi.name === KPI_FORMGROUP.PERFORM_CARBON_PERFORMANCE.name
          || kpi.name === KPI_FORMGROUP.PERFORM_OVERALL_ECO_VADIS.name
          || kpi.name === KPI_FORMGROUP.PERFORM_OVERALL_ECO_VADIS_DEVELOPMENT.name
          || kpi.name === KPI_FORMGROUP.PERFORM_GE_CORE_REQUIREMENT.name
          || kpi.name === KPI_FORMGROUP.PERFORM_APQP4Wind.name
          || kpi.name === KPI_FORMGROUP.PERFORM_MAJOR_DISRUPTION.name) {
          this.formGroup.controls[kpi.formGroupName]['controls']['scoringBelow'].disable();
          this.formGroup.controls[kpi.formGroupName]['controls']['scoringMeet'].disable();
          this.formGroup.controls[kpi.formGroupName]['controls']['scoringExceed'].disable();

          if (kpi.name === KPI_FORMGROUP.PERFORM_MAJOR_DISRUPTION.name) {
            this.formGroup.controls[kpi.formGroupName]['controls']['rangeMeetExceed'].disable();
            this.formGroup.controls[kpi.formGroupName]['controls']['rangeExceedOperator'].disable();
          }

          this.formGroup.controls[kpi.formGroupName].updateValueAndValidity();
        }

        this.formGroup.controls[kpi.formGroupName].setValidators(this.scoringValidator(kpi.maxScore, kpi));
      });
    });
  }

  private addFormGroupToFormGroup(): FormGroup {
    const formGroupName = new FormGroup({
      rangeBelowOperator: new FormControl('', [CustomValidator.required]),
      rangeExceedOperator: new FormControl('', [CustomValidator.required]),
      rangeMeetBelow: new FormControl('', [CustomValidator.required]),
      rangeMeetExceed: new FormControl('', [CustomValidator.required]),
      scoringBelow: new FormControl('', [CustomValidator.required]),
      scoringMeet: new FormControl('', [CustomValidator.required]),
      scoringExceed: new FormControl('', [CustomValidator.required]),
    }, {
      validators: [this.compareOperator]
    });
    return formGroupName;
  }

  public getParentCompany() {
    this.spinner.show();
    this.scorecardSettingService.getParentCompany().subscribe(res => {
      this.spinner.hide();
      if (res) {
        this.parentNames = res.data.map(item => ({ name: item, value: item }));
      }
    }, err => this.spinner.hide());
  }

  // private getGSLByParent(parent: any[]) {
  //   this.scorecardService.getGSLsByParent(parent).subscribe(res => {
  //     this.gsls = res.data.map(item => ({ value: item.g, name: item.s + '/' + item.g }));
  //     this.gslValues = res.data.map(item => ({ value: item.g, name: item.s + '/' + item.g }));
  //     this.formGroup.controls.gsls.setValue(this.gslValues.map(item => item.value));
  //   });
  // }

  public getOne(parent, year, gsl) {
    this.spinner.show();
    this.scorecardSettingService.getScorecardSetting(parent, year, gsl).subscribe(res => {
      this.spinner.hide();
      if (res) {
        this.configSelected = res.data;
        this.formGroup.controls.year.disable();
        this.formGroup.controls.parentNames.disable();
        this.formGroup.controls.gsls.disable();
        this.formGroup.controls.type.disable();
        this.formGroup.controls.year.setValue(moment(new Date(year, 1, 1)));
        this.formGroup.controls.parentNames.setValue([parent]);
        this.formGroup.controls.gsls.setValue(gsl ? [gsl] : undefined);
        this.configSelected.settings.forEach(item => {
          if (this.formGroup.controls[item.indicators]) {
            this.formGroup.controls[item.indicators].setValue({
              rangeBelowOperator: (item.rangeBelowOperator !== undefined && !this.formGroup.controls[item.indicators].disabled) ? item.rangeBelowOperator : '',
              rangeExceedOperator: (item.rangeExceedOperator !== undefined && !this.formGroup.controls[item.indicators].disabled) ? item.rangeExceedOperator : '',
              rangeMeetBelow: (item.rangeMeetBelow !== undefined && !this.formGroup.controls[item.indicators].disabled) ? item.rangeMeetBelow : '',
              rangeMeetExceed: (item.rangeMeetExceed !== undefined && !this.formGroup.controls[item.indicators].disabled) ? item.rangeMeetExceed : '',
              scoringBelow: typeof (item.scoringBelow) === 'number' ? item.scoringBelow : '',
              scoringMeet: typeof (item.scoringMeet) === 'number' ? item.scoringMeet : '',
              scoringExceed: typeof (item.scoringExceed) === 'number' ? item.scoringExceed : ''
            });
          }
        });
      }
    }, err => this.spinner.hide());
  }

  chosenYearHandler(normalizedYear: Moment, datepicker: OwlDateTimeComponent<Moment>) {
    const ctrlValue = this.formGroup.controls.year.value;
    ctrlValue.year(normalizedYear.year());
    this.formGroup.controls.year.setValue(ctrlValue);
    datepicker.close();
  }

  public getKeys(key) {
    return Object.keys(key);
  }

  public getValues(key) {
    return Object.values(key);
  }

  public parseInt(str: string) {
    return parseInt(str, 10);
  }

  private compareOperator(control: AbstractControl): ValidationErrors | null {
    const below = control.get('rangeBelowOperator').value;
    const exceed = control.get('rangeExceedOperator').value;

    if (below === exceed) { return { 'noMatch': true }; }
    if (Math.abs(below - exceed) === 1) {
      if (below === 2 && exceed === 3 || below === 3 && exceed === 2) {
        return null;
      }
      return { 'noMatch': true };
    }

    return null;
  }

  private scoringValidator(max, kpi) {
    return (control: AbstractControl): ValidationErrors | null => {
      const formGroup = control.parent as FormGroup;
      const below = control.get('scoringBelow').value;
      const meet = control.get('scoringMeet').value;
      const exceed = control.get('scoringExceed').value;
      const behaviorKPIs = ['RELATION_COMPLIANCE_INTEGRITY', 'RELATION_TECHNOLOGY_INNOVATION',
        'RELATION_RESPONSIVENESS', 'RELATION_SC_COMPETENCY_FOOTPRINT',
        'RELATION_GE_FLEXIBILITY_SWITCH'];
      const performKPIs = ['PERFORM_TOTAL_QUALITY_SCORE', 'PERFORM_OTD_PROMISED_DATE',
        'PERFORM_LEAD_TIME_TARGET', 'PERFORM_YOY_COST_OUT_PCO',
        'PERFORM_PAYMENT_DATE_TARGET', 'PERFORM_FINANCIAL_HEALTH_RATING', 'PERFORM_SUSTAINABILITY'];
      let errors: ValidationErrors = {};
      let totalScoreBehavior = 0;
      for (let item = 0; item <= behaviorKPIs.length; item++) {
        const kpiControl = formGroup.get(behaviorKPIs[item]);
        if (kpiControl) {
          const kpiValue = kpiControl.get('scoringExceed').value;
          totalScoreBehavior += Number(kpiValue) || 0;
        }
      }
      totalScoreBehavior !== 85 ? this.behaviorScoreValid = true : this.behaviorScoreValid = false;
      if (totalScoreBehavior !== 85 && behaviorKPIs.includes(kpi.formGroupName)) { errors['behaviornotvalid'] = true };
      behaviorKPIs.forEach((kpiName) => {
        const control = formGroup.get(kpiName);
        if (!this.behaviorScoreValid) {
          control.setErrors(null);
        }
      });
      let totalScorePerform = 0;
      for (let item = 0; item <= performKPIs.length; item++) {
        const kpiControl = formGroup.get(performKPIs[item]);
        if (kpiControl) {
          const kpiValue = kpiControl.get('scoringExceed').value;
          totalScorePerform += Number(kpiValue) || 0;
        }
      }
      totalScorePerform !== 115 ? this.performScoreValid = true : this.performScoreValid = false;
      if (totalScorePerform !== 115 && performKPIs.includes(kpi.formGroupName)) { errors['performnotvalid'] = true };
      performKPIs.forEach((kpiName) => {
        const control = formGroup.get(kpiName);
        if (!this.performScoreValid) {
          control.setErrors(null);
        }
      });
      if (this.parseInt(below) > max || this.parseInt(meet) > max ||
        this.parseInt(exceed) > max) { errors['greater'] = true };
      if (this.parseInt(below) < 0 || this.parseInt(meet) < 0 ||
        this.parseInt(exceed) < 0) { errors['negative'] = true };
      return Object.keys(errors).length > 0 ? errors : null;
    }
  }

  public save() {
    let errorMessages = [];
    let behaviorScoreNotValid = false;
    let performScoreNotValid = false;
    if (this.formGroup.valid) {
      const data = this.formGroup.getRawValue();
      if (!data.parentNames && !data.gsls && data.type === 1) {
        this.toastr.error(MESSAGE_TOAST.PARENT_COMPANY_GSL_REQUIRED);
        return;
      }
      const payload = {
        parents: data.type === 1 ? !data.parentNames ? [] : data.parentNames : ['Default Setting'],
        gsls: data.type === 1 ? !data.gsls ? [] : data.gsls : [],
        year: new Date(data.year.format()).getFullYear(),
        settings: Object.keys(KPI_FORMGROUP).map(item => {
          return ({
            id: this.configSelected.settings ? this.findKPIId(item) : null,
            indicators: item,
            rangeMeetBelow: data[item].rangeMeetBelow,
            rangeMeetExceed: data[item].rangeMeetExceed,
            scoringBelow: data[item].scoringBelow,
            scoringMeet: data[item].scoringMeet,
            scoringExceed: data[item].scoringExceed,
            rangeBelowOperator: data[item].rangeBelowOperator,
            rangeExceedOperator: data[item].rangeExceedOperator,
          });
        }) as KPISetting[],
      } as ScorecardSettingModel;
      this.spinner.show();
      if (!this.isEdit) {
        this.scorecardSettingService.create(payload).subscribe(res => {
          this.spinner.hide();
          if (res) {
            this.toastr.success(MESSAGE_TOAST.ADD_SCORECARD_SETTING);
            this.router.navigate([PATH_ROUTING.PATH_SRM, PATH_ROUTING.PATH_ADMIN, PATH_ROUTING.PATH_SCORECARD_SETTING]);
          }
        }, err => this.spinner.hide());
      } else {
        this.scorecardSettingService.update(payload, payload.parents, payload.year, payload.gsls).subscribe(res => {
          this.spinner.hide();
          if (res) {
            this.toastr.success(MESSAGE_TOAST.EDIT_SCORECARD_SETTING);
            this.router.navigate([PATH_ROUTING.PATH_SRM, PATH_ROUTING.PATH_ADMIN, PATH_ROUTING.PATH_SCORECARD_SETTING]);
          }
        }, err => this.spinner.hide());
      }
    } else {
      Object.keys(KPI_FORMGROUP).forEach(kpi => {
        if (this.formGroup.controls[kpi].errors && this.formGroup.controls[kpi].errors['noMatch']
          && this.formGroup.controls[kpi].value.rangeBelowOperator
          && this.formGroup.controls[kpi].value.rangeExceedOperator) {
          errorMessages.push(KPI_FORMGROUP[kpi].name + ': ' + MESSAGE_TOAST.OPERATORS_WRONG);
        }
        if (this.formGroup.controls[kpi].errors && this.formGroup.controls[kpi].errors['greater']) {
          errorMessages.push(KPI_FORMGROUP[kpi].name + ': ' + MESSAGE_TOAST.SCORING_WRONG + ' ' + KPI_FORMGROUP[kpi].maxScore);
        }
        if (this.formGroup.controls[kpi].errors && this.formGroup.controls[kpi].errors['negative']) {
          errorMessages.push(KPI_FORMGROUP[kpi].name + ': ' + MESSAGE_TOAST.SCORING_NEGATIVE);
        }
        if (this.formGroup.controls[kpi].errors && this.formGroup.controls[kpi].errors['behaviornotvalid']){
          behaviorScoreNotValid = true;
        }
        if (this.formGroup.controls[kpi].errors && this.formGroup.controls[kpi].errors['performnotvalid']){
          performScoreNotValid = true;
        }
      });
      if (this.behaviorScoreValid && behaviorScoreNotValid) {
        errorMessages.push(MESSAGE_TOAST.BEHAVIOR_SCORING_NOTVALID);
      }
      if (this.performScoreValid && performScoreNotValid) {
        errorMessages.push(MESSAGE_TOAST.PERFORM_SCORING_NOTVALID);
      }
      if(errorMessages.length > 0){
        errorMessages.forEach(msg => this.toastr.error(msg));
        return;
      }
    }
  }

  private findKPIId(kpiName) {
    return this.configSelected.settings.filter(item => item.indicators === kpiName)[0].id;
  }

  public checkDisabled(kpi) {
    if (kpi.name === KPI_FORMGROUP.PERFORM_ESCAPING_DEFECTS.name || kpi.name === KPI_FORMGROUP.PERFORM_YOY_COST_OUT_SUPPLIER_PRICE.name
      || kpi.name === KPI_FORMGROUP.PERFORM_OTD_PLAN_NEEDS.name || kpi.name === KPI_FORMGROUP.PERFORM_DATE_LATE_PROMISED_DATE.name
      || kpi.name === KPI_FORMGROUP.PERFORM_DATE_LATE_PLAN_NEEDS.name) {
      return true;
    }
  }

  private markFormGroupTouched(formGroup: FormGroup): void {
    (Object as any).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

}